<template>
  <div>
    <b-container>
      <b-row>
        <div class="w-100 text-center mt-3">
          <h3>POS</h3>
        </div>
      </b-row>

      <b-row class="mt-3 bg-dark p-2 rounded">
        <b-col>
          <b-form>
            <b-form-input  v-model="invoice.paymentType">
            </b-form-input>
          </b-form>
        </b-col>

      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    invoice: {
      client: {},
      items: {},
      desc: '',
      paid: true,
      paidAmount: 0,
      paymentType: 0,
    },
  }),
};
</script>

<style>

</style>
